import { render } from "./UnDeveloped.vue?vue&type=template&id=c88346f8&scoped=true"
import script from "./UnDeveloped.vue?vue&type=script&lang=js"
export * from "./UnDeveloped.vue?vue&type=script&lang=js"

import "./UnDeveloped.vue?vue&type=style&index=0&id=c88346f8&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/alice/alice_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c88346f8"]])

export default __exports__